import { render, staticRenderFns } from "./showTopic.vue?vue&type=template&id=cbc6ac72"
import script from "./showTopic.vue?vue&type=script&lang=js"
export * from "./showTopic.vue?vue&type=script&lang=js"
import style0 from "./showTopic.vue?vue&type=style&index=0&id=cbc6ac72&prod&scoepd=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports